module.exports = __webpack_public_path__ + "img/username-icon.c7bcbd96.svg";